/* =============================================================================
   Theme JS — progressive enhancement only.
   The store must remain usable with JS disabled (DESIGN.md §7).
   ============================================================================= */
(function () {
  'use strict';

  var R = window.themeRoutes || {};
  var money = window.themeMoneyFormat || '{{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    value = parts.join('.');
    return money.replace(/\{\{\s*amount\s*\}\}/, value)
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
                .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
                .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
  }

  function trapFocus(container, opener) {
    var sel = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(container.querySelectorAll(sel), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    container._releaseFocus = function () {
      container.removeEventListener('keydown', onKey);
      if (opener && typeof opener.focus === 'function') opener.focus();
    };
  }

  /* ---------------------------------------------------------------------------
     Header — stuck state
     --------------------------------------------------------------------------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------------------------------------------------------------------
     Mobile navigation
     --------------------------------------------------------------------------- */
  var nav = document.querySelector('[data-mobile-nav]');
  if (nav) {
    var navOpener = null;
    function openNav(btn) {
      navOpener = btn;
      nav.classList.add('is-open');
      nav.removeAttribute('hidden');
      nav.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      trapFocus(nav, navOpener);
      var close = nav.querySelector('[data-nav-close]');
      if (close) close.focus();
    }
    function closeNav() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (nav._releaseFocus) nav._releaseFocus();
      setTimeout(function () { if (!nav.classList.contains('is-open')) nav.setAttribute('hidden', ''); }, 260);
    }
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-nav-open]');
      if (open) { e.preventDefault(); openNav(open); }

      var close = e.target.closest('[data-nav-close]');
      if (close) {
        /* Every link inside the drawer carries data-nav-close so that tapping
           one also shuts the menu — but they still have to navigate. Cancel the
           default only for controls that are not real links, otherwise the
           whole mobile menu becomes a set of dead ends. */
        if (!close.hasAttribute('href')) e.preventDefault();
        closeNav();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
    });
  }

  /* ---------------------------------------------------------------------------
     Cart drawer
     --------------------------------------------------------------------------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');

  function openDrawer(opener) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    trapFocus(drawer, opener);
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (drawer._releaseFocus) drawer._releaseFocus();
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.setAttribute('hidden', ''); }, 260);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && drawer) { e.preventDefault(); openDrawer(opener); }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-overlay]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* Re-render cart drawer + count from the Section Rendering API */
  function refreshCart(open) {
    return fetch(R.cart + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-drawer-contents]');
        var current = document.querySelector('[data-drawer-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        return fetch(R.cart + '.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
          el.classList.remove('is-bumped');
          void el.offsetWidth;
          el.classList.add('is-bumped');
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        if (open) openDrawer();
        return cart;
      });
  }
  window.themeRefreshCart = refreshCart;

  /* Add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || !drawer) return;
    e.preventDefault();
    var btn = form.querySelector('[data-atc]');
    var label = btn ? btn.querySelector('[data-atc-label]') : null;
    var original = label ? label.textContent : '';
    var errorBox = form.querySelector('[data-form-error]');
    if (errorBox) { errorBox.textContent = ''; errorBox.hidden = true; }
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.disabled = true; }
    if (label) label.textContent = form.dataset.addingText || 'Adding…';

    fetch(R.cartAdd, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart.');
        if (label) label.textContent = form.dataset.addedText || 'Added';
        return refreshCart(true).then(function () {
          setTimeout(function () { if (label) label.textContent = original; }, 900);
        });
      })
      .catch(function (err) {
        if (label) label.textContent = original;
        if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.disabled = false; }
      });
  });

  /* Line item quantity + remove */
  function changeLine(key, quantity) {
    return fetch(R.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { return refreshCart(false); });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.dataset.lineRemove, 0); return; }

    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    e.preventDefault();
    var wrap = step.closest('[data-qty]');
    var input = wrap.querySelector('input');
    var min = parseInt(input.min || '1', 10);
    var next = (parseInt(input.value, 10) || min) + parseInt(step.dataset.qtyStep, 10);
    if (next < min) next = min;
    if (input.max && next > parseInt(input.max, 10)) next = parseInt(input.max, 10);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) q = 0;
    changeLine(input.dataset.lineQty, q);
  });

  /* ---------------------------------------------------------------------------
     Product variant selection
     --------------------------------------------------------------------------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = document.getElementById(picker.dataset.formId);
    if (!form) return;
    var idInput = form.querySelector('[data-variant-id]');
    var dataEl = document.getElementById(picker.dataset.variantData);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    function selected() {
      return Array.prototype.map.call(picker.querySelectorAll('input:checked'), function (i) { return i.value; });
    }

    function update() {
      var opts = selected();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });

      /* Reflect chosen option text next to each group label */
      picker.querySelectorAll('[data-option-index]').forEach(function (group) {
        var i = parseInt(group.dataset.optionIndex, 10);
        var out = group.querySelector('[data-option-value]');
        if (out && opts[i]) out.textContent = opts[i];
      });

      var atc = form.querySelector('[data-atc]');
      var label = atc ? atc.querySelector('[data-atc-label]') : null;
      var priceEl = document.querySelector('[data-price-target]');

      /* Reflect availability across the option groups, and keep each pack's
         price accurate for the colour that is currently selected. */
      picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var group = input.closest('[data-option-index]');
        if (!group) return;
        var gi = parseInt(group.dataset.optionIndex, 10);
        var exists = variants.some(function (v) {
          return v.options.every(function (o, i) { return i === gi ? o === input.value : o === opts[i]; });
        });
        /* Only disable combinations that do not exist at all. A variant that
           exists but is sold out stays selectable so the buyer sees why. */
        input.disabled = !exists && !input.checked;
      });

      var packWrap = picker.querySelector('[data-pack-option-index]');
      if (packWrap) {
        var packIdx = parseInt(packWrap.dataset.packOptionIndex, 10);
        packWrap.querySelectorAll('[data-pack-price]').forEach(function (el) {
          var candidate = variants.find(function (v) {
            return v.available && v.options.every(function (o, i) {
              return i === packIdx ? o === el.dataset.packPrice : o === opts[i];
            });
          });
          if (candidate) { el.textContent = formatMoney(candidate.price); el.hidden = false; }
          else { el.hidden = true; }
        });
      }

      if (!match) {
        if (idInput) idInput.value = '';
        if (atc) { atc.disabled = true; }
        if (label) label.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = match.id;

      if (priceEl) priceEl.innerHTML = formatMoney(match.price);
      document.querySelectorAll('[data-sticky-price]').forEach(function (el) { el.innerHTML = formatMoney(match.price); });

      if (atc) {
        atc.disabled = !match.available;
        if (label) label.textContent = match.available ? (form.dataset.atcText || 'Add to cart') : 'Sold out';
      }

      /* Keep the URL shareable without a reload */
      if (window.history.replaceState && match.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }

      /* Jump the gallery to this variant's image */
      if (match.featured_media_id) {
        var slide = document.querySelector('[data-media-id="' + match.featured_media_id + '"]');
        if (slide) slide.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
      }

      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: match } }));
    }

    picker.addEventListener('change', update);
    update();
  });

  /* ---------------------------------------------------------------------------
     Product gallery
     --------------------------------------------------------------------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelector('[data-gallery-slides]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var dots = gallery.querySelectorAll('[data-gallery-dot]');
    if (!slides) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var target = slides.querySelector('[data-media-id="' + thumb.dataset.galleryThumb + '"]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });

    function syncActive() {
      var index = Math.round(slides.scrollLeft / slides.clientWidth);
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }
    var ticking = false;
    slides.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { syncActive(); ticking = false; });
    }, { passive: true });
    syncActive();
  });

  /* ---------------------------------------------------------------------------
     Sticky mobile add-to-cart — appears once the real form scrolls away
     --------------------------------------------------------------------------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var anchor = document.querySelector('[data-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { rootMargin: '0px 0px -80px 0px' }).observe(anchor);
  }

  /* Sticky bar delegates to the real form so there is one source of truth */
  document.querySelectorAll('[data-sticky-submit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.querySelector('[data-product-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.querySelector('[data-atc]').click();
    });
  });

  /* ---------------------------------------------------------------------------
     Pause the tap pulse when it is offscreen (DESIGN.md §8)
     --------------------------------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var pulseObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.querySelectorAll('span').forEach(function (ring) {
          ring.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
        });
      });
    }, { threshold: 0 });
    document.querySelectorAll('.tap-pulse').forEach(function (p) { pulseObserver.observe(p); });
  }

  /* ---------------------------------------------------------------------------
     Bulk / custom enquiry — client-side validation with visible error states
     --------------------------------------------------------------------------- */
  document.querySelectorAll('[data-validate]').forEach(function (form) {
    form.setAttribute('novalidate', '');
    form.addEventListener('submit', function (e) {
      var firstBad = null;
      form.querySelectorAll('[required]').forEach(function (field) {
        var errorEl = form.querySelector('[data-error-for="' + field.id + '"]');
        var bad = !field.value.trim() || (field.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(field.value));
        field.setAttribute('aria-invalid', bad ? 'true' : 'false');
        if (errorEl) {
          errorEl.textContent = bad
            ? (field.type === 'email' && field.value.trim() ? 'Enter a valid email address.' : 'This field is required.')
            : '';
        }
        if (bad && !firstBad) firstBad = field;
      });
      if (firstBad) { e.preventDefault(); firstBad.focus(); }
    });
  });
})();
